export interface LSACategory {
  vertical: string
  local: string
  job_type_id: string
}
export const LSA_NICHE_OPTIONS = ['home_services', 'real_estate', 'legal']
export const CATEGORY = [
  'accountant',
  'acupuncturist',
  'air_duct_cleaner',
  'alcohol_treatment',
  'animal_shelter',
  'appliance_repair',
  'architect',
  'assisted_living',
  'babysitter',
  'bankruptcy_lawyer',
  'beauty_school',
  'business_lawyer',
  'car_repair',
  'carpenter',
  'carpet_cleaning',
  'child_care',
  'chiropractor',
  'cleaning_service',
  'contract_lawyer',
  'countertop_pro',
  'criminal_lawyer',
  'dance_instructor',
  'disability_lawyer',
  'driving_instructor',
  'dui_lawyer',
  'electrician',
  'energy_efficiency_pro',
  'estate_lawyer',
  'event_planner',
  'family_lawyer',
  'fencing_pro',
  'financial_planner',
  'first_aid_trainer',
  'flooring_pro',
  'foundation_pro',
  'funeral_home',
  'garage_door_pro',
  'general_contractor',
  'handyman',
  'home_inspector',
  'home_security',
  'home_theater',
  'hvac',
  'immigration_lawyer',
  'interior_designer',
  'ip_lawyer',
  'junk_removal',
  'labor_lawyer',
  'landscaper',
  'language_instructor',
  'lawn_care',
  'litigation_lawyer',
  'locksmith',
  'malpractice_lawyer',
  'massage_center',
  'massage_school',
  'mover',
  'nursing_home',
  'painter',
  'personal_injury_lawyer',
  'personal_trainer',
  'pest_control',
  'pet_adoption',
  'pet_boarding',
  'pet_grooming',
  'pet_trainer',
  'photographer',
  'plumber',
  'pool_cleaner',
  'pool_contractor',
  'preschool',
  'psychologist',
  'real_estate_agent',
  'real_estate_lawyer',
  'rehab',
  'roofer',
  'sewage_pro',
  'siding_pro',
  'smart_home',
  'snow_removal',
  'spa',
  'tax_lawyer',
  'tax_specialist',
  'therapist',
  'towing_pro',
  'traffic_lawyer',
  'tree_service',
  'tutor',
  'upholstery_cleaner',
  'veterinarian',
  'videographer',
  'water_damage',
  'weight_loss_service',
  'window_cleaner',
  'window_repair',
  'windshield_repair_pro',
  'yoga_instructor',
]
export const LSA: { [key: string]: Array<LSACategory> } = {
  accountant: [
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'accountant_other',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'bankruptcy_tax_litigation',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'bookkeeping',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'business_consulting',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'debt_collection_relief',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'irs_representation_resolution',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'payroll',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'tax_planning_business',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'tax_planning_individual',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'tax_return_business',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'tax_return_individual',
    },
    {
      vertical: 'accountant',
      local: 'en-US',
      job_type_id: 'trusts_estates_accounting',
    },
  ],
  acupuncturist: [
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'acupressure',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'acupuncture',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'acupuncturist_other',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'cupping',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'gua_sha',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'heat_therapy',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'herbal_therapy',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'infrared_therapy',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'moxibustion',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'qigong',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'shiatsu',
    },
    {
      vertical: 'acupuncturist',
      local: 'en-US',
      job_type_id: 'tui_na',
    },
  ],
  air_duct_cleaner: [
    {
      vertical: 'air_duct_cleaner',
      local: 'en-US',
      job_type_id: 'air_duct_cleaning',
    },
    {
      vertical: 'air_duct_cleaner',
      local: 'en-US',
      job_type_id: 'air_duct_filter_replacement',
    },
    {
      vertical: 'air_duct_cleaner',
      local: 'en-US',
      job_type_id: 'air_duct_other',
    },
    {
      vertical: 'air_duct_cleaner',
      local: 'en-US',
      job_type_id: 'dryer_vent_cleaning',
    },
    {
      vertical: 'air_duct_cleaner',
      local: 'en-US',
      job_type_id: 'furnace_cleaning',
    },
    {
      vertical: 'air_duct_cleaner',
      local: 'en-US',
      job_type_id: 'indoor_air_quality_testing',
    },
  ],
  alcohol_treatment: [
    {
      vertical: 'alcohol_treatment',
      local: 'en-US',
      job_type_id: 'alcohol_treatment_other',
    },
  ],
  animal_shelter: [
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_cat_adoption',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_dog_adoption',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_other',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_other_animal_adoption',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_other_veterinary_services',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_spay_neuter',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'animal_shelter_vaccinations',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'lost_stray_found_animals',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'pet_license',
    },
    {
      vertical: 'animal_shelter',
      local: 'en-US',
      job_type_id: 'pet_surrender',
    },
  ],
  appliance_repair: [
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'appliance_other',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_dishwasher',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_dryer',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_freezer',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_microwave',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_oven',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_refrigerator',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_refrigerator_freezer',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_stove_cooktop',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_stove_cooktop_oven',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_washer',
    },
    {
      vertical: 'appliance_repair',
      local: 'en-US',
      job_type_id: 'repair_washer_dryer',
    },
  ],
  architect: [
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: '3d_architectural_rendering',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'adaptive_reuse_historical_renovation',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'architect_other',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'architectural_designing',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'architectural_engineering',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'building_code_analysis_permit_coordination',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'consulting',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'home_building_improvement',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'interior_design_architect',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'planning_zoning_approval_assistance',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'project_managing_architect',
    },
    {
      vertical: 'architect',
      local: 'en-US',
      job_type_id: 'site_master_planning',
    },
  ],
  assisted_living: [
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_housekeeping_and_laundry',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_meal_services',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_memory_care',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_other',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_rehabilitation_services',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_transportation',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'assisted_living_wellness_programs',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'daily_living_assistance',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'medication_management',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'short_term_stays',
    },
    {
      vertical: 'assisted_living',
      local: 'en-US',
      job_type_id: 'social_and_recreational_activities',
    },
  ],
  babysitter: [
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'babysitter_other',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'event_babysitting',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'homework_assistance',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'housekeeping_laundry',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'meal_preparation',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'nanny_services',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'overnight_babysitting',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'pick_up_and_drop_off',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'shopping_errand',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'special_needs_care',
    },
    {
      vertical: 'babysitter',
      local: 'en-US',
      job_type_id: 'virtual_babysitting',
    },
  ],
  bankruptcy_lawyer: [
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'agriculture_bankruptcy',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'bankruptcy_lawyer_other',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'bankruptcy_litigation',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'chapter_11_bankruptcy',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'chapter_13_bankruptcy',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'chapter_7_bankruptcy',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'corporate_bankruptcy',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'creditor_harassment',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'debt_settlement',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'foreclosure_bankruptcy_lawyer',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'personal_bankruptcy',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'repossession',
    },
    {
      vertical: 'bankruptcy_lawyer',
      local: 'en-US',
      job_type_id: 'wage_garnishment',
    },
  ],
  beauty_school: [
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_barbering',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_business_management',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_cosmetology',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_esthetics',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_hair_cutting',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_hair_design',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_makeup',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_massage_therapy',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_nail_technology',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_other',
    },
    {
      vertical: 'beauty_school',
      local: 'en-US',
      job_type_id: 'beauty_school_retail_training',
    },
  ],
  business_lawyer: [
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'banking_finance_law',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'business_lawyer_other',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'business_licenses_permits',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'business_litigation',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'business_taxes',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'business_transactions_business_lawyer',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'commercial_bankruptcy',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'commercial_contracts_business_lawyer',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'employment_law_business_lawyer',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'incorporation_restructuring',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'insurance_law',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'intellectual_property_law',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'mergers_acquisitions_business_lawyer',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'partnership_agreements_business_lawyer',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'patents_copyrights_trademarks',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'securities_law',
    },
    {
      vertical: 'business_lawyer',
      local: 'en-US',
      job_type_id: 'shareholder_disputes',
    },
  ],
  car_repair: [
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'air_and_cabin_filter',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'battery',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'body_and_trim',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'brakes',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'car_air_conditioning',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'car_electrical',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'car_repair_other',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'check_engine_light_diagnostic',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'exhaust',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'oil_change',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'steering_suspension',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'tires',
    },
    {
      vertical: 'car_repair',
      local: 'en-US',
      job_type_id: 'transmission',
    },
  ],
  carpenter: [
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'cabinetry',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'carpenter_other',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'decking',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'drywalling',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'fencing',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'general_installations',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'general_repairs_maintenance',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'remodeling',
    },
    {
      vertical: 'carpenter',
      local: 'en-US',
      job_type_id: 'shelving_storage',
    },
  ],
  carpet_cleaning: [
    {
      vertical: 'carpet_cleaning',
      local: 'en-US',
      job_type_id: 'carpet_cleaning_other',
    },
    {
      vertical: 'carpet_cleaning',
      local: 'en-US',
      job_type_id: 'clean_area_rugs',
    },
    {
      vertical: 'carpet_cleaning',
      local: 'en-US',
      job_type_id: 'clean_carpet',
    },
    {
      vertical: 'carpet_cleaning',
      local: 'en-US',
      job_type_id: 'clean_drapes_and_curtains',
    },
    {
      vertical: 'carpet_cleaning',
      local: 'en-US',
      job_type_id: 'clean_upholstery',
    },
    {
      vertical: 'carpet_cleaning',
      local: 'en-US',
      job_type_id: 'remove_pet_stains_and_odors',
    },
  ],
  child_care: [
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'after_school_care',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'all_hours_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'bilingual_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'child_care_other',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'drop_in_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'full_time_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'in_home_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'infant_programs',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'part_time_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'pre_kindergarten_programs',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'preschool_programs',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'school_age_programs',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'special_needs_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'summer_daycare',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'toddler_programs',
    },
    {
      vertical: 'child_care',
      local: 'en-US',
      job_type_id: 'weekend_daycare',
    },
  ],
  chiropractor: [
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'chiropractor_acupuncture',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'chiropractor_chiropractic',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'chiropractor_massage_therapy',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'chiropractor_other',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'diagnosis',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'eastern_medicine',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'exercise_counseling',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'pain_management',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'physical_therapy',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'spinal_adjustments',
    },
    {
      vertical: 'chiropractor',
      local: 'en-US',
      job_type_id: 'sports_medicine',
    },
  ],
  cleaning_service: [
    {
      vertical: 'cleaning_service',
      local: 'en-US',
      job_type_id: 'cleaner_other',
    },
    {
      vertical: 'cleaning_service',
      local: 'en-US',
      job_type_id: 'deep_clean',
    },
    {
      vertical: 'cleaning_service',
      local: 'en-US',
      job_type_id: 'moving_clean',
    },
    {
      vertical: 'cleaning_service',
      local: 'en-US',
      job_type_id: 'office_clean',
    },
    {
      vertical: 'cleaning_service',
      local: 'en-US',
      job_type_id: 'standard_clean',
    },
  ],
  contract_lawyer: [
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'assignment_of_contract',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'business_transactions_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'commercial_contracts_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'contract_dispute',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'contract_lawyer_other',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'contract_negotiation',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'contract_review',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'employment_contracts_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'franchise_agreements',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'mergers_acquisitions_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'non_disclosure_agreements_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'partnership_agreements_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'power_of_attorney_contract_lawyer',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'security_agreements',
    },
    {
      vertical: 'contract_lawyer',
      local: 'en-US',
      job_type_id: 'warranties',
    },
  ],
  countertop_pro: [
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'bathroom_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'bathroom_wall_panels',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'countertop_design',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'countertop_installation',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'countertop_pro_other',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'fireplace_facade',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'granite_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'kitchen_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'kitchen_wall_panels',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'laminate_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'marble_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'quartz_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'remodeling_countertop_pro',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'repair_maintenance_countertop_pro',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'stone_slab_countertops',
    },
    {
      vertical: 'countertop_pro',
      local: 'en-US',
      job_type_id: 'tile_countertops',
    },
  ],
  criminal_lawyer: [
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'corporate_representation',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'criminal_immigration_defense',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'criminal_lawyer_other',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'domestic_violence',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'drug_possession',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'duis_reckless_driving',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'expungement',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'federal_crimes',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'felonies',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'petty_crimes_misdemeanors',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'restraining_orders',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'sex_offenses',
    },
    {
      vertical: 'criminal_lawyer',
      local: 'en-US',
      job_type_id: 'three_strikes_law',
    },
  ],
  dance_instructor: [
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_african',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_ballet',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_ballroom',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_belly',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_bollywood',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_contemporary',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_folk_traditional',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_hip_hop',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_jazz',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_kids_classes',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_latin',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_modern',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_other',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_tap',
    },
    {
      vertical: 'dance_instructor',
      local: 'en-US',
      job_type_id: 'dance_instructor_wedding',
    },
  ],
  disability_lawyer: [
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'disability_hearings',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'disability_lawyer_other',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'long_term_disability',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'short_term_disability',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'social_security_disability_insurance',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'ssa_claim_reconsideration',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'ssa_disability_appeals',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'ssa_disability_applications',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'ssa_disability_benefits',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'ssa_family_benefits',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'ssa_impairment_listings',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'supplemental_security_income',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'veterans_disability_benefits',
    },
    {
      vertical: 'disability_lawyer',
      local: 'en-US',
      job_type_id: 'workers_compensation_disability_lawyer',
    },
  ],
  driving_instructor: [
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'behind_the_wheel_lessons',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'commercial_license_training',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'defensive_driving_lessons',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'drivers_education_classes',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'driving_instructor_other',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'manual_transmission_lessons',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'motorcycle_lessons',
    },
    {
      vertical: 'driving_instructor',
      local: 'en-US',
      job_type_id: 'traffic_school',
    },
  ],
  dui_lawyer: [
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'dui_dwi_dui_lawyer',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'dui_injuries_dui_lawyer',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'dui_lawyer_other',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'dui_with_accident',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'felony_dui',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'invalid_tests',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'multiple_offenses',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'reckless_driving_dui_lawyer',
    },
    {
      vertical: 'dui_lawyer',
      local: 'en-US',
      job_type_id: 'underage_dui',
    },
  ],
  electrician: [
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'electric_car_charger',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'electrician_other',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'electrician_remodeling',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'install_fan',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'install_ground_wire',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'install_light_fixtures',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'install_outdoor_lighting',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'install_outlets_switches',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'install_security_system',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'relocate_outlets_switches',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'repair_fan',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'repair_light_fixtures',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'repair_outlets_switches',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'repair_panel',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'replace_upgrade_panel',
    },
    {
      vertical: 'electrician',
      local: 'en-US',
      job_type_id: 'restore_power',
    },
  ],
  energy_efficiency_pro: [
    {
      vertical: 'energy_efficiency_pro',
      local: 'en-US',
      job_type_id: 'energy_efficiency_pro_other',
    },
  ],
  estate_lawyer: [
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'charitable_giving',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'contests_litigation',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'deeds',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'estate_lawyer_other',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'estate_planning_lawyer',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'guardianship_estate_lawyer',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'medical_power_of_attorney',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'power_of_attorney_estate_lawyer',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'probate_estate_lawyer',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'trusts',
    },
    {
      vertical: 'estate_lawyer',
      local: 'en-US',
      job_type_id: 'wills',
    },
  ],
  event_planner: [
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'anniversary_planner',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'baby_shower_planner',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'bar_and_bat_mitzvah_planner',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'birthday_party',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'children_party',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'corporate_and_conference_planner',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'event_planner_other',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'quinceanera_planner',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'religious_event',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'retirement_party',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'school_event',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'theme_party',
    },
    {
      vertical: 'event_planner',
      local: 'en-US',
      job_type_id: 'wedding_and_engagement_planner',
    },
  ],
  family_lawyer: [
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'adoption',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'child_support',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'contested_divorce',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'debt_division',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'family_lawyer_other',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'guardianship_family_lawyer',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'mediation_family_lawyer',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'modifications_of_orders',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'parent_timesharing',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'paternity',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'prenuptial_postnuptial_agreements',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'probate_family_lawyer',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'property_divisions',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'protective_orders_domestic_violence_issues',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'spousal_support_alimony',
    },
    {
      vertical: 'family_lawyer',
      local: 'en-US',
      job_type_id: 'uncontested_divorce',
    },
  ],
  fencing_pro: [
    {
      vertical: 'fencing_pro',
      local: 'en-US',
      job_type_id: 'custom_construction',
    },
    {
      vertical: 'fencing_pro',
      local: 'en-US',
      job_type_id: 'fence_design',
    },
    {
      vertical: 'fencing_pro',
      local: 'en-US',
      job_type_id: 'fencing_other',
    },
    {
      vertical: 'fencing_pro',
      local: 'en-US',
      job_type_id: 'installation_fencing_pro',
    },
    {
      vertical: 'fencing_pro',
      local: 'en-US',
      job_type_id: 'repairs_maintenance_fencing_pro',
    },
  ],
  financial_planner: [
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'education_savings',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'estate_financial_planning',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'financial_planning',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'financial_planning_other',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'home_purchase',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'insurance',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'investment_advising',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'retirement_savings',
    },
    {
      vertical: 'financial_planner',
      local: 'en-US',
      job_type_id: 'tax_planning',
    },
  ],
  first_aid_trainer: [
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'advanced_cardiac_life_support',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'aed_defibrillator',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'basic_life_support',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'cpr',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'first_aid',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'first_aid_trainer_other',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'pediatric_advanced_life_support',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'pediatric_cpr_first_aid',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'pet_cpr_first_aid',
    },
    {
      vertical: 'first_aid_trainer',
      local: 'en-US',
      job_type_id: 'wilderness_first_aid',
    },
  ],
  flooring_pro: [
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'baseboards',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'carpet',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'flooring_other',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'hardwood',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'installation_flooring_pro',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'marble',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'polishing',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'refinishing',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'repair_maintenance_flooring_pro',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'stair_flooring',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'tile',
    },
    {
      vertical: 'flooring_pro',
      local: 'en-US',
      job_type_id: 'wood_floor_sanding',
    },
  ],
  foundation_pro: [
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'basement_waterproofing',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'crawl_spaces',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'foundation_drainage',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'foundation_installation',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'foundation_pro_other',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'foundation_raising',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'repairs_maintenance_foundation_pro',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'slab_foundation',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'steel_pier_pilings',
    },
    {
      vertical: 'foundation_pro',
      local: 'en-US',
      job_type_id: 'water_moisture_control',
    },
  ],
  funeral_home: [
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'burials',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'caskets',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'cremation',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'funeral_home_flowers',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'funeral_home_other',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'funeral_home_transportation_transfers',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'funeral_home_veteran_services',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'funerals',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'gravestones',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'grief_services',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'memorials',
    },
    {
      vertical: 'funeral_home',
      local: 'en-US',
      job_type_id: 'urns',
    },
  ],
  garage_door_pro: [
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'garage_door_other',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'general_maintenance',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'install_garage_door',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'install_opener',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'repair_cables',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'repair_garage_door',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'repair_gate',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'repair_rollers_tracks',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'replace_door_panels',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'replace_opener',
    },
    {
      vertical: 'garage_door_pro',
      local: 'en-US',
      job_type_id: 'replace_springs',
    },
  ],
  general_contractor: [
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'accessory_buildings',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'bathroom_remodel',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'decks_patio',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'exterior_finishing',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'foundations_concrete',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'general_contractor_commercial_projects',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'general_contractor_other',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'home_addition',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'home_building',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'home_remodel_renovation',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'interior_finishing',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'kitchen_remodel',
    },
    {
      vertical: 'general_contractor',
      local: 'en-US',
      job_type_id: 'roofing',
    },
  ],
  handyman: [
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'assemble_furniture',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'clean_gutters',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'handyman_other',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'install_drywall',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'install_fan',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'install_flooring',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'install_tile',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'install_water_fixtures',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'mount_tv',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'paint_indoors',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'paint_outdoors',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'repair_drywall',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'repair_fan',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'repair_flooring',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'repair_water_fixtures',
    },
    {
      vertical: 'handyman',
      local: 'en-US',
      job_type_id: 'replace_tile',
    },
  ],
  home_inspector: [
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'buyer_seller_inspection',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'commercial_properties',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'fire_safety',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'fireplace_chimney',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'full_home_inspection',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_electrical',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_foundation',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_hvac',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_mold',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_new_construction',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_other',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_plumbing',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_roof',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_inspector_structural',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'home_warranty',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'water_testing',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'well_or_septic_system',
    },
    {
      vertical: 'home_inspector',
      local: 'en-US',
      job_type_id: 'wood_insects',
    },
  ],
  home_security: [
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'access_control',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'alarm_systems',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'commercial_security_systems',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'fire_smoke_detection',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'home_security_doors',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'home_security_locks',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'home_security_other',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'home_security_windows',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'monitoring_services',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'residential_security_systems',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'smart_home_integration',
    },
    {
      vertical: 'home_security',
      local: 'en-US',
      job_type_id: 'video_surveillance',
    },
  ],
  home_theater: [
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'audio_video_installation',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'commercial_projects',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'home_theater_design',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'home_theater_lighting',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'home_theater_other',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'home_theater_smart_home_integration',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'install_tv',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'network_it_services',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'outdoor_installations',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'soundproofing',
    },
    {
      vertical: 'home_theater',
      local: 'en-US',
      job_type_id: 'whole_house_audio_video',
    },
  ],
  hvac: [
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'ac_maintenance',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'clean_ducts_vents',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'ductless_heating_and_ac_services',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'heating_maintenance',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'hvac_maintenance',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'hvac_other',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'install_ac',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'install_ducts_vents',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'install_heating_system',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'install_thermostat',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'repair_ac',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'repair_ducts_vents',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'repair_heating_system',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'repair_hvac',
    },
    {
      vertical: 'hvac',
      local: 'en-US',
      job_type_id: 'repair_thermostat',
    },
  ],
  immigration_lawyer: [
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'asylum',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'citizenship',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'deportation',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'family_based_immigration',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'green_card',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'immigration_lawyer_other',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'investment_visa',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'outbound_work_permits',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'student_visa',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'visitor_visa',
    },
    {
      vertical: 'immigration_lawyer',
      local: 'en-US',
      job_type_id: 'work_visa',
    },
  ],
  interior_designer: [
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'appliance_selection',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'cabinetry_molding_hardware_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'decorating',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'door_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'exterior_building_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'flooring_selection',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'interior_designer_other',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'landscaping_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'lighting_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'multifamily_housing_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'room_planning',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'stone_brick_stucco_design',
    },
    {
      vertical: 'interior_designer',
      local: 'en-US',
      job_type_id: 'window_design',
    },
  ],
  ip_lawyer: [
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'advertisements',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'copyright',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'export_control',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'franchises',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'international_ip',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'ip_lawyer_other',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'ip_strategy',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'ip_transactions',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'licensing',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'litigation_ip_lawyer',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'non_disclosure_agreements_ip_lawyer',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'patents',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'technology_transfer',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'trade_secrets',
    },
    {
      vertical: 'ip_lawyer',
      local: 'en-US',
      job_type_id: 'trademarks',
    },
  ],
  junk_removal: [
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'appliance_removal',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'construction_waste_removal',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'donation_pickup',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'electronic_waste_removal',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'furniture_removal',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'general_junk_removal',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'hazardous_waste_removal',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'house_garage_cleanout',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'junk_removal_other',
    },
    {
      vertical: 'junk_removal',
      local: 'en-US',
      job_type_id: 'yard_waste_removal',
    },
  ],
  labor_lawyer: [
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'employment_contracts_labor_lawyer',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'employment_law_labor_lawyer',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'exempt_employee_status',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'labor_law',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'labor_lawyer_other',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'labor_negotiations',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'privacy_rights',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'sexual_harassment',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'unpaid_overtime',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'whistle_blowing',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'workers_compensation_labor_lawyer',
    },
    {
      vertical: 'labor_lawyer',
      local: 'en-US',
      job_type_id: 'wrongful_termination',
    },
  ],
  landscaper: [
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'artificial_turf_installation',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'concrete_masonry',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'driveway_landscaping',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'garden_decorations',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'grading_resloping',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'hardscapes',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'landscape_design',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'landscape_installations',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'landscaper_other',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'outdoor_steps',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'outdoor_water_feature',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'paving_driveway_walkway',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'retaining_walls',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'sidewalk_walkway_landscaping',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'sod_seeding',
    },
    {
      vertical: 'landscaper',
      local: 'en-US',
      job_type_id: 'stone_masonry',
    },
  ],
  language_instructor: [
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'arabic',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'english',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'french',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'german',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'hebrew',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'italian',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'japanese',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'korean',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'language_instructor_other',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'mandarin',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'portuguese',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'russian',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'sign_language',
    },
    {
      vertical: 'language_instructor',
      local: 'en-US',
      job_type_id: 'spanish',
    },
  ],
  lawn_care: [
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'irrigation_system_repair_maintenance',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'lawn_care_other',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'lawn_mowing_maintenance',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'lawn_pest_control',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'mulching',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'seeding',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'sod_installation',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'weed_control',
    },
    {
      vertical: 'lawn_care',
      local: 'en-US',
      job_type_id: 'yard_cleanup',
    },
  ],
  litigation_lawyer: [
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'appeals',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'case_assessment_litigation_lawyer',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'civil_litigation',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'commercial_litigation',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'contracts_and_agreements',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'criminal_litigation',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'litigation_lawyer_other',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'mediation_litigation_lawyer',
    },
    {
      vertical: 'litigation_lawyer',
      local: 'en-US',
      job_type_id: 'settlements',
    },
  ],
  locksmith: [
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'building_lockout',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'copy_building_key',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'copy_vehicle_key',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'install_hardware',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'locksmith_other',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'new_key_fob',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'rekey_lock',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'repair_hardware',
    },
    {
      vertical: 'locksmith',
      local: 'en-US',
      job_type_id: 'vehicle_lockout',
    },
  ],
  malpractice_lawyer: [
    {
      vertical: 'malpractice_lawyer',
      local: 'en-US',
      job_type_id: 'consent_issues',
    },
    {
      vertical: 'malpractice_lawyer',
      local: 'en-US',
      job_type_id: 'diagnosis_errors',
    },
    {
      vertical: 'malpractice_lawyer',
      local: 'en-US',
      job_type_id: 'malpractice_lawyer_other',
    },
    {
      vertical: 'malpractice_lawyer',
      local: 'en-US',
      job_type_id: 'medical_negligence',
    },
    {
      vertical: 'malpractice_lawyer',
      local: 'en-US',
      job_type_id: 'treatment_errors',
    },
  ],
  massage_center: [
    {
      vertical: 'massage_center',
      local: 'en-US',
      job_type_id: 'massage_center_other',
    },
  ],
  massage_school: [
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_advanced_neuromuscular_therapy',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_business_and_ethics',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_clinical_therapies',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_continuing_education',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_deep_tissue_massage',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_energetics',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_hydrotherapy',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_lymphatic_massage',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_online_massage_therapy',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_other',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_prenatal_massage',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_sports_massage',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_student_massage_clinic',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_school_swedish_massage',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_theory',
    },
    {
      vertical: 'massage_school',
      local: 'en-US',
      job_type_id: 'massage_therapy_training',
    },
  ],
  mover: [
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'in_state_move',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'local_move',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'mover_other',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'moving_junk_removal',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'moving_storage',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'out_of_state_move',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'oversized_item_move',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'packing_unpacking',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'senior_move',
    },
    {
      vertical: 'mover',
      local: 'en-US',
      job_type_id: 'vehicle_transport',
    },
  ],
  nursing_home: [
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'cardiac_care',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'general_medical_care',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'hospice',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'iv_therapy',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'nursing_home_meal_services',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'nursing_home_memory_care',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'nursing_home_other',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'nursing_home_pain_management',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'nursing_home_rehabilitation_services',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'nursing_home_wellness_programs',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'outpatient_rehabilitation',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'post_hospital_care',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'respiratory_and_pulmonary_care',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'senior_activity_programs',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'short_term_rehabilitation',
    },
    {
      vertical: 'nursing_home',
      local: 'en-US',
      job_type_id: 'wound_care',
    },
  ],
  painter: [
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'exterior_painting',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'interior_painting',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'paint_cabinets',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'paint_doors',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'painter_other',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'repair_drywall',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'repair_water_damage',
    },
    {
      vertical: 'painter',
      local: 'en-US',
      job_type_id: 'staining',
    },
  ],
  personal_injury_lawyer: [
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'assault_battery',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'auto_accidents',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'bicycle_accidents',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'catastrophic_injuries',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'dog_bites',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'dui_injuries_personal_injury_lawyer',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'medical_malpractice',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'motorcycle_accidents',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'pain_suffering',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'pedestrian_accidents',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'personal_injury_lawyer_other',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'product_liability',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'slip_fall',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'uninsured_motorist_claims',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'workers_compensation_personal_injury_lawyer',
    },
    {
      vertical: 'personal_injury_lawyer',
      local: 'en-US',
      job_type_id: 'wrongful_death',
    },
  ],
  personal_trainer: [
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'aerobics',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'athletic_performance',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'circuit_training',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'endurance',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'fitness_assessment',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'hiit',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'nutritional_counseling',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'personal_trainer_other',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'strength_conditioning',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'weight_loss',
    },
    {
      vertical: 'personal_trainer',
      local: 'en-US',
      job_type_id: 'yoga',
    },
  ],
  pest_control: [
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'ants',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'bed_bugs',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'bees',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'cockroaches',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'fleas_or_mites',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'hornets_or_wasps',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'mosquitoes',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'pest_control_other',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'pest_inspection',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'rodents',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'spiders',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'termites',
    },
    {
      vertical: 'pest_control',
      local: 'en-US',
      job_type_id: 'wildlife',
    },
  ],
  pet_adoption: [
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_birds',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_cats',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_dogs',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_farm_animals',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_fish',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_other',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_reptiles',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_small_mammals',
    },
    {
      vertical: 'pet_adoption',
      local: 'en-US',
      job_type_id: 'pet_adoption_special_needs_animals',
    },
  ],
  pet_boarding: [
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'cat_boarding',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'cat_grooming',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'cat_sitting_in_home',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_boarding',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_boarding_with_training',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_daycare',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_grooming',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_sitting_in_home',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_training',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'dog_walking',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'other_pet_boarding',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'other_pet_daycare',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'other_pet_grooming',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'other_pet_sitting_in_home',
    },
    {
      vertical: 'pet_boarding',
      local: 'en-US',
      job_type_id: 'pet_boarding_other',
    },
  ],
  pet_grooming: [
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'cat_bathing',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'cat_ear_cleaning',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'cat_grooming_and_styling',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'cat_nail_trimming',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_anal_gland_expression',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_bathing_and_blow_dry',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_ear_cleaning',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_flea_and_tick_treatment',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_full_service_grooming',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_grooming_and_styling',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_nail_trimming',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'dog_teeth_brushing',
    },
    {
      vertical: 'pet_grooming',
      local: 'en-US',
      job_type_id: 'pet_grooming_other',
    },
  ],
  pet_trainer: [
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'aggressive_dog_training',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'behavior_modification',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'obedience_training',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'offleash_training',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'pet_trainer_other',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'puppy_training',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'service_animal_training',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'sport_trick_training',
    },
    {
      vertical: 'pet_trainer',
      local: 'en-US',
      job_type_id: 'training_other_animals',
    },
  ],
  photographer: [
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'corporate_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'events_and_parties_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'family_and_group_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'headshots_and_portraits',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'individual_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'maternity_and_newborn_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'photographer_other',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'product_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'real_estate_photo',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'school_portraits',
    },
    {
      vertical: 'photographer',
      local: 'en-US',
      job_type_id: 'wedding_and_engagement_photo',
    },
  ],
  plumber: [
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'find_leak',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'install_faucet',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'install_garbage_disposal',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'install_shower',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'install_toilet',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'install_water_heater',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'plumbing_other',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_faucet',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_garbage_disposal',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_outdoor_systems',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_pipe',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_sewer',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_shower',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_toilet',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'repair_water_heater',
    },
    {
      vertical: 'plumber',
      local: 'en-US',
      job_type_id: 'unclog_drain',
    },
  ],
  pool_cleaner: [
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'commercial_pool_cleaning_maintenance',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'equipment_maintenance_repair',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'one_time_pool_cleaning',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'ongoing_pool_cleaning',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'pool_cleaner_other',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'pool_cleaner_water_features',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'seasonal_opening_closing',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'spa_hot_tub_cleaning',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'spa_hot_tub_repairs',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'tile_pool_wall_cleaning',
    },
    {
      vertical: 'pool_cleaner',
      local: 'en-US',
      job_type_id: 'water_testing_balancing',
    },
  ],
  pool_contractor: [
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'jetted_lap_pools',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_construction',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_commercial_projects',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_custom_designs',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_other',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_renovation',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_repair_cracks',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_repair_tile',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_resurfacing',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_contractor_water_features',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'pool_hot_tub_equipment',
    },
    {
      vertical: 'pool_contractor',
      local: 'en-US',
      job_type_id: 'spa_hot_tub_installation',
    },
  ],
  preschool: [
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'bilingual_programs',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'early_preschool',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'full_day_preschool',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'half_day_preschool',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'kindergarten_classes',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'montessori_programs',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'play_based_preschool',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'preschool_infant_programs',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'preschool_other',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'reggio_emilia_preschool',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'special_needs_programs',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'summer_camp',
    },
    {
      vertical: 'preschool',
      local: 'en-US',
      job_type_id: 'waldorf_preschool',
    },
  ],
  psychologist: [
    {
      vertical: 'psychologist',
      local: 'en-US',
      job_type_id: 'psychologist_other',
    },
  ],
  real_estate_agent: [
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'buyer_agent',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'first_time_home_buyer',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'foreclosed_properties',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'luxury_properties',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'new_construction',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'property_management',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'real_estate_agent_other',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'relocation',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'rentals',
    },
    {
      vertical: 'real_estate_agent',
      local: 'en-US',
      job_type_id: 'sellers_agent',
    },
  ],
  real_estate_lawyer: [
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'commercial_real_estate',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'easements',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'encroachment',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'foreclosure_real_esate_lawyer',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'landlord_tenant_law',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'litigation_real_estate_lawyer',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'mortgage_lending_law',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'neighbor_hoa_disputes',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'property_damage',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'purchase_agreements',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'real_estate_contracts_transactions',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'real_estate_lawyer_other',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'residential_real_estate',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'title_services',
    },
    {
      vertical: 'real_estate_lawyer',
      local: 'en-US',
      job_type_id: 'trespassing',
    },
  ],
  rehab: [
    {
      vertical: 'rehab',
      local: 'en-US',
      job_type_id: 'rehab_other',
    },
  ],
  roofer: [
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'attic_venting',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'gutter_installation',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'gutter_repair',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'roof_inspection',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'roof_installation',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'roof_repair',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'roofer_other',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'skylight_installation',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'skylight_repair',
    },
    {
      vertical: 'roofer',
      local: 'en-US',
      job_type_id: 'storm_wind_damage_roof_repair',
    },
  ],
  sewage_pro: [
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_cleaning',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_excavation',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_inspection',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_installation',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_locating',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_maintenance_repairs',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_pro_other',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_pumping',
    },
    {
      vertical: 'sewage_pro',
      local: 'en-US',
      job_type_id: 'sewage_removal_demolition',
    },
  ],
  siding_pro: [
    {
      vertical: 'siding_pro',
      local: 'en-US',
      job_type_id: 'remodeling_siding_pro',
    },
    {
      vertical: 'siding_pro',
      local: 'en-US',
      job_type_id: 'repair_maintenance_siding_pro',
    },
    {
      vertical: 'siding_pro',
      local: 'en-US',
      job_type_id: 'siding_installation',
    },
    {
      vertical: 'siding_pro',
      local: 'en-US',
      job_type_id: 'siding_pro_other',
    },
    {
      vertical: 'siding_pro',
      local: 'en-US',
      job_type_id: 'siding_removal',
    },
  ],
  smart_home: [
    {
      vertical: 'smart_home',
      local: 'en-US',
      job_type_id: 'smart_home_other',
    },
  ],
  snow_removal: [
    {
      vertical: 'snow_removal',
      local: 'en-US',
      job_type_id: 'commercial_snow_removal',
    },
    {
      vertical: 'snow_removal',
      local: 'en-US',
      job_type_id: 'residential_plowing',
    },
    {
      vertical: 'snow_removal',
      local: 'en-US',
      job_type_id: 'residential_shoveling_blowing',
    },
    {
      vertical: 'snow_removal',
      local: 'en-US',
      job_type_id: 'salt_sand_deicing',
    },
    {
      vertical: 'snow_removal',
      local: 'en-US',
      job_type_id: 'snow_relocation',
    },
    {
      vertical: 'snow_removal',
      local: 'en-US',
      job_type_id: 'snow_removal_other',
    },
  ],
  spa: [
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'body_polish',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'body_wrap',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'facial',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'hydrotherapy',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'manicure',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'massage',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'pedicure',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'peels',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'spa_other',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'spa_packages',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'tanning',
    },
    {
      vertical: 'spa',
      local: 'en-US',
      job_type_id: 'waxing',
    },
  ],
  tax_lawyer: [
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'civil_tax_litigation',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'corporate_taxes',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'criminal_tax_litigation',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'estate_tax_planning',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'failure_to_file',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'innocent_spouse_relief',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'international_tax_services',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'irs_tax_problems',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'non_collectible_status',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'offer_in_compromise',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'tax_audits',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'tax_lawyer_other',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'tax_liens_levies',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'tax_planning_lawyer',
    },
    {
      vertical: 'tax_lawyer',
      local: 'en-US',
      job_type_id: 'tax_relief',
    },
  ],
  tax_specialist: [
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'accounting_support',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'business_incorporation_restructuring',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'cryptocurrency_taxes',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'irs_audit_representation',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'irs_filing',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'irs_problem_consulting',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'new_business_services',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'payroll_support',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'tax_planning_tax_specialist',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'tax_preparation',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'tax_problem_consulting_tax_specialist',
    },
    {
      vertical: 'tax_specialist',
      local: 'en-US',
      job_type_id: 'tax_specialist_other',
    },
  ],
  therapist: [
    {
      vertical: 'therapist',
      local: 'en-US',
      job_type_id: 'therapist_other',
    },
  ],
  towing_pro: [
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'battery_service',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'car_towing',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'fuel_delivery',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'local_hauling',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'long_distance_hauling',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'motorcycle_towing',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'special_vehicle_towing',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'tire_change',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'towing_other',
    },
    {
      vertical: 'towing_pro',
      local: 'en-US',
      job_type_id: 'vehicle_lockout',
    },
  ],
  traffic_lawyer: [
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'case_assessment_traffic_lawyer',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'cdl_traffic_ticket',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'dui_dwi_traffic_lawyer',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'fixit_ticket',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'parking_ticket',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'reckless_driving_traffic_lawyer',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'red_light_ticket',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'speeding_ticket',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'suspended_license',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'traffic_lawyer_other',
    },
    {
      vertical: 'traffic_lawyer',
      local: 'en-US',
      job_type_id: 'traffic_ticket',
    },
  ],
  tree_service: [
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'cabling_and_bracing',
    },
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'stump_removal',
    },
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'tree_planting',
    },
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'tree_removal',
    },
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'tree_service_other',
    },
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'tree_transplanting',
    },
    {
      vertical: 'tree_service',
      local: 'en-US',
      job_type_id: 'tree_trimming_and_pruning',
    },
  ],
  tutor: [
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_computer_science',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_foreign_languages',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_geography',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_government_and_economics',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_history',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_homework_help',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_math',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_other',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_reading_and_writing',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_science',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_special_education',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_test_pre_college_entrance',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_test_prep_grad_school_entrance',
    },
    {
      vertical: 'tutor',
      local: 'en-US',
      job_type_id: 'tutor_test_prep_k8',
    },
  ],
  upholstery_cleaner: [
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'area_rug_cleaning',
    },
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'drapery_and_blind_cleaning',
    },
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'leather_cleaning',
    },
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'mattress_cleaning',
    },
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'upholstery_cleaner_other',
    },
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'upholstery_cleaning',
    },
    {
      vertical: 'upholstery_cleaner',
      local: 'en-US',
      job_type_id: 'upholstery_water_damage_cleanup',
    },
  ],
  veterinarian: [
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'bird_exotic_animal_care',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'farm_barn_animal_care',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'microchipping',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_allergies',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_behavior_counseling',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_dental_care',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_dermatology',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_emergency_care',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_end_of_life_care',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_examinations',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_nutrition_counseling',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_other',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_preventive_care',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_spay_neuter',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_surgery',
    },
    {
      vertical: 'veterinarian',
      local: 'en-US',
      job_type_id: 'veterinarian_vaccinations',
    },
  ],
  videographer: [
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'aerial_videography',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'documentary_video_production',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'family_video_production',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'live_streaming',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'photography',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'product_demonstrations',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'promotional_video_production',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'real_estate_video_production',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'special_event_video_production',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'video_editing',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'videographer_other',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'voice_overs',
    },
    {
      vertical: 'videographer',
      local: 'en-US',
      job_type_id: 'wedding_video_production',
    },
  ],
  water_damage: [
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'fire_damage_cleanup_repair',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_cleanup_repair',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_flooring',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_mold_inspection',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_mold_removal',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_other',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_painting',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_pest_control',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_plumbing',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_remodeling',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_roofing',
    },
    {
      vertical: 'water_damage',
      local: 'en-US',
      job_type_id: 'water_damage_sewage_cleanup',
    },
  ],
  weight_loss_service: [
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'adult_weight_loss_programs',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'diet_and_nutrition_counseling',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'kids_weight_loss_programs',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'metabolic_testing',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'weight_loss_consultation_and_training',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'weight_loss_fitness_programs',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'weight_loss_meal_planning',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'weight_loss_personal_training',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'weight_loss_service_other',
    },
    {
      vertical: 'weight_loss_service',
      local: 'en-US',
      job_type_id: 'weight_loss_wellness_programs',
    },
  ],
  window_cleaner: [
    {
      vertical: 'window_cleaner',
      local: 'en-US',
      job_type_id: 'glass_and_mirror_cleaning',
    },
    {
      vertical: 'window_cleaner',
      local: 'en-US',
      job_type_id: 'gutter_cleaning',
    },
    {
      vertical: 'window_cleaner',
      local: 'en-US',
      job_type_id: 'power_pressure_washing',
    },
    {
      vertical: 'window_cleaner',
      local: 'en-US',
      job_type_id: 'rooftop_skylight_cleaning',
    },
    {
      vertical: 'window_cleaner',
      local: 'en-US',
      job_type_id: 'window_cleaner_other',
    },
    {
      vertical: 'window_cleaner',
      local: 'en-US',
      job_type_id: 'window_cleaning',
    },
  ],
  window_repair: [
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'door_installation',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'door_repair',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'glass_installation',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'skylight_installation',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'skylight_repair',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'window_boardup',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'window_installation',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'window_repair',
    },
    {
      vertical: 'window_repair',
      local: 'en-US',
      job_type_id: 'window_repair_other',
    },
  ],
  windshield_repair_pro: [
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'install_new_wiper_blades',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'repair_power_window',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'repair_water_leak',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'repair_windshield',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'replace_rear_window',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'replace_side_view_mirrors',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'replace_side_window',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'replace_sunroof',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'replace_windshield',
    },
    {
      vertical: 'windshield_repair_pro',
      local: 'en-US',
      job_type_id: 'windshield_other',
    },
  ],
  yoga_instructor: [
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'ashtanga',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'hatha',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'hot_yoga',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'iyengar',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'kundalini',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'meditation',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'power_yoga',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'restorative',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'vinyasa',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'yin',
    },
    {
      vertical: 'yoga_instructor',
      local: 'en-US',
      job_type_id: 'yoga_instructor_other',
    },
  ],
}
